import { useState } from "react";
import CustomSelect from "../../shared/CustomSelect";
import CustomInput from "../../shared/CustomInput";
import { Upload } from "lucide-react";
import { uploadImage } from "../../sdk/upload/upload";
import LoanApplicationModal from "../../shared/LoanApplicationModal";

const BankStatement = ({
  closeBankStatement,
  activeIndex,
  handleNextStep,
  incomeDetails,
  setIncomeDetails,
  loading,
}) => {
  const [uploadedFile, setUploadedFile] = useState(null);

  const handleFileChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    try {
      const response = await uploadImage(file);
      setIncomeDetails((prev) => ({
        ...prev,
        bankStatementUrl: response?.url,
      }));
      setUploadedFile({ url: response?.url, name: file.name, type: file.type });
    } catch (error) {
      console.error("Upload failed", error);
    }
  };
  return (
    <LoanApplicationModal
      closeBioInformation={closeBankStatement}
      activeIndex={activeIndex}
      handleNextStep={handleNextStep}
      loading={loading}
    >
      <p className="text-[#000000] font-normal text-[14px]">
        Create a New Loan Application
      </p>
      <p className="text-[#000000] font-semibold text-[20px]">
        Borrower’s Income Details
      </p>
      <p className="text-[#5C5C5C] text-[14px] font-normal">
        Upload Bank statement
      </p>
      <div className="flex items-start gap-[20px] my-[10px]">
        <div className="flex w-[48%] flex-col">
          <label
            className="text-[#222222] font-medium text-[12px] truncate"
            htmlFor="Statement Type"
          >
            Statement Type*
          </label>
          <CustomSelect
            name="Statement Type"
            value={incomeDetails?.bankStatementPeriod}
            onChange={(e) =>
              setIncomeDetails({
                ...incomeDetails,
                bankStatementPeriod: e.target.value,
              })
            }
            options={["3 months", "6 months"]}
          />
        </div>
        <div className="flex w-[48%] flex-col">
          <label
            className="text-[#222222] font-medium text-[12px] truncate"
            htmlFor="Statement passcode"
          >
            Statement Passcode (optional)
          </label>
          <CustomInput
            placeholder="Enter your statement passcode"
            type="text"
            value={incomeDetails?.bankStatementCode}
            onChange={(e) =>
              setIncomeDetails({
                ...incomeDetails,
                bankStatementCode: e.target.value,
              })
            }
          />
        </div>
      </div>
      <div className="flex items-start gap-[20px] my-[10px]">
        <div className="flex w-[48%] flex-col">
          <label
            className="text-[#222222] font-medium text-[12px] truncate"
            htmlFor="Bank Name"
          >
            Bank Name (optional)
          </label>
          <CustomInput
            placeholder="Enter your bank name"
            type="text"
            value={incomeDetails?.bankName}
            onChange={(e) =>
              setIncomeDetails({
                ...incomeDetails,
                bankName: e.target.value,
              })
            }
          />
        </div>
      </div>
      <div className="mb-[15px] w-full">
        <p className="text-[#222222] font-medium text-[13px]">
          Bank statement{" "}
          <span className="font-normal text-[#5C5C5C]">
            .jpeg or .png file only
          </span>
        </p>
        <label htmlFor="fileInput">
          <div className="h-[130px] w-full flex flex-col justify-center items-center gap-[10px] rounded-[8px] border-[0.7px] border-[#A8A8A8] bg-white cursor-pointer">
            {uploadedFile ? (
              <div className="px-[20px] flex items-center justify-center">
                {uploadedFile.type.startsWith("image/") ? (
                  <img
                    src={uploadedFile.url}
                    alt="Uploaded"
                    className="h-[100px] object-contain"
                  />
                ) : (
                  <p className="text-sm text-[#000000]">{uploadedFile.name}</p>
                )}
              </div>
            ) : (
              <>
                <Upload />
                <p className="text-[#000000] text-[12px] font-normal">
                  Drag and Drop file here or{" "}
                  <span className="text-[#000000] underline">Choose file</span>{" "}
                  here
                </p>
              </>
            )}
          </div>
        </label>
        <input
          type="file"
          accept=".jpeg,.jpg,.png,.pdf"
          className="hidden"
          id="fileInput"
          onChange={handleFileChange}
        />
      </div>
    </LoanApplicationModal>
  );
};

export default BankStatement;
